import { Icon, IconProps } from "@chakra-ui/react";

const RotatedSquare = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <path
        d="M1.57419 11.3891C1.39157 11.2071 1.24667 10.9907 1.1478 10.7526C1.04894 10.5144 0.998047 10.259 0.998047 10.0011C0.998047 9.74326 1.04894 9.48791 1.1478 9.24973C1.24667 9.01155 1.39157 8.79522 1.57419 8.61314L8.61119 1.57614C8.79327 1.39352 9.0096 1.24862 9.24778 1.14976C9.48596 1.05089 9.74131 1 9.99919 1C10.2571 1 10.5124 1.05089 10.7506 1.14976C10.9888 1.24862 11.2051 1.39352 11.3872 1.57614L18.4242 8.61314C18.7923 8.98127 18.9991 9.48055 18.9991 10.0011C18.9991 10.5217 18.7923 11.021 18.4242 11.3891L11.3872 18.4261C11.0191 18.7942 10.5198 19.001 9.99919 19.001C9.4786 19.001 8.97932 18.7942 8.61119 18.4261L1.57419 11.3891Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </Icon>
  );
};

export default RotatedSquare;
